import {TabList, TabListProps} from '@headlessui/react';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import {DocumentListFlags} from '@/repositories/beneva-api/endpoints/documents';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import HeaderItem from './item';

type Props = TabListProps & {
  ['data-testid']?: string;
  flags?: DocumentListFlags;
};

const Header = ({className, flags, ...props}: Props) => {
  const {t} = useTranslation();

  return (
    <TabList
      className={clsx(
        'mb-8 flex items-center justify-between gap-6 rounded-2 bg-purple-100 p-1 font-medium text-charcoal',
        className,
      )}
      {...props}
    >
      <HeaderItem
        data-testid="menu-tabs-header-incomplete"
        hasNotification={flags?.incomplete}
        trackingKey={WEB_CLICK_TRACKING_KEY.VIEW_INCOMPLETE_DOCUMENTS}
      >
        {t('components.document-menu.header.incomplete')}
      </HeaderItem>

      <HeaderItem
        data-testid="menu-tabs-header-pending"
        hasNotification={flags?.pending}
        trackingKey={WEB_CLICK_TRACKING_KEY.VIEW_PENDING_DOCUMENTS}
      >
        {t('components.document-menu.header.pending')}
      </HeaderItem>

      <HeaderItem
        data-testid="menu-tabs-header-sent"
        hasNotification={flags?.sent}
        trackingKey={WEB_CLICK_TRACKING_KEY.VIEW_SENT_DOCUMENTS}
      >
        {t('components.document-menu.header.sent')}
      </HeaderItem>
    </TabList>
  );
};

export default Header;
